import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'
import PropTypes from 'prop-types'
import useMobileDetect from 'helpers/mobile-detect'

import styles from './show-story.module.scss'

export default function Index (props) {
  const [description, setDescription] = useState('description')
  const currentDevice = useMobileDetect()

  const configModal = {
    ...props,
    centered: currentDevice.width < 768
  }

  useEffect(() => {
    if (props.testimonial) {
      setDescription(props.testimonial.story)
    }
  }, [props])

  const CustomCloseButton = () => {
    return (
      <button type='button' className='close' onClick={props.onHide}>
        <img src='/static/images/logo/close-white.svg'/>
        <span className='sr-only'>Close</span>
      </button>
    )
  }

  return (
    <Modal
      {...configModal}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      className={styles['show-story']}
    >
      <Modal.Header>
        {
          props.testimonial &&
          props.testimonial.imgFeature &&
          // <div style={{ backgroundImage: `url(${API_URL + props.testimonial.imgFeature.url})` }} className={'img'}/>
          <img src={API_URL + props.testimonial.imgFeature.url} className={'img'} />
        }
        <CustomCloseButton/>
      </Modal.Header>

      <Modal.Body>
        <h2 className={styles['show-story__title']}>{ props.testimonial.title }</h2>
        <p id='show-story' dangerouslySetInnerHTML={{ __html: description }}></p>
      </Modal.Body>

      <Modal.Footer className='justify-content-center'>
        <img src='/static/images/logo/modal-lgo-footer.svg' alt='Dolce Diet'/>
      </Modal.Footer>
    </Modal>
  )
}

Index.propTypes = {
  testimonial: PropTypes.object,
  onHide: PropTypes.func,
  content: PropTypes.string
}
